import { useState } from 'react'
import { Bot, Users, MessageSquare, Send, Contact } from 'lucide-react'
import { useTelegramBots } from '@/api/hooks/useTelegram'
import { BotsTab } from './BotsTab'
import { GroupsTab } from './GroupsTab'
import { KeywordsTab } from './KeywordsTab'
import { BroadcastTab } from './BroadcastTab'
import { ContactsTab } from './ContactsTab'

const tabs = [
  { id: 'bots', label: 'Bots', icon: Bot },
  { id: 'groups', label: 'Grupos', icon: Users },
  { id: 'contacts', label: 'Contatos', icon: Contact },
  { id: 'keywords', label: 'Keywords', icon: MessageSquare },
  { id: 'broadcast', label: 'Broadcast', icon: Send },
] as const

type TabId = (typeof tabs)[number]['id']

export function Telegram() {
  const [activeTab, setActiveTab] = useState<TabId>('bots')
  const { data: bots } = useTelegramBots()
  const [selectedBotId, setSelectedBotId] = useState<string | null>(null)

  const activeBotId = selectedBotId || bots?.[0]?.id || null

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-xl font-bold tracking-tight">Telegram</h1>
        <p className="text-sm text-muted-foreground">Gerencie bots, grupos, automações e broadcasts</p>
      </div>

      {/* Tabs */}
      <div className="flex gap-1 border-b border-border">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`flex items-center gap-2 px-4 py-2.5 text-sm font-medium border-b-2 transition-colors ${
              activeTab === tab.id
                ? 'border-primary text-primary'
                : 'border-transparent text-muted-foreground hover:text-foreground'
            }`}
          >
            <tab.icon className="h-4 w-4" />
            {tab.label}
          </button>
        ))}
      </div>

      {/* Content */}
      {activeTab === 'bots' && <BotsTab onSelectBot={setSelectedBotId} />}
      {activeTab === 'groups' && <GroupsTab botId={activeBotId} bots={bots || []} onBotChange={setSelectedBotId} />}
      {activeTab === 'contacts' && <ContactsTab botId={activeBotId} bots={bots || []} onBotChange={setSelectedBotId} />}
      {activeTab === 'keywords' && <KeywordsTab botId={activeBotId} bots={bots || []} onBotChange={setSelectedBotId} />}
      {activeTab === 'broadcast' && <BroadcastTab botId={activeBotId} bots={bots || []} onBotChange={setSelectedBotId} />}
    </div>
  )
}
